const RETURN_KEY = 'keycloak_sso_return_to';

export function rememberReturnPath(path: string): void {
  if (!path || path === '/' || path.startsWith('/login')) return;
  try {
    sessionStorage.setItem(RETURN_KEY, path);
  } catch {
  }
}

export function peekReturnPath(): string | null {
  try {
    return sessionStorage.getItem(RETURN_KEY);
  } catch {
    return null;
  }
}

export function takeReturnPath(): string | null {
  const to = peekReturnPath();
  if (to) {
    try {
      sessionStorage.removeItem(RETURN_KEY);
    } catch {
    }
  }
  return to;
}
